import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ConfirmReinstateEnrollmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  userFullName: string;
  onConfirm: () => Promise<void>;
}

function ConfirmReinstateEnrollmentModal({
  isOpen,
  onClose,
  userFullName,
  onConfirm,
}: ConfirmReinstateEnrollmentModalProps) {
  const [isWorking, setIsWorking] = useState(false);

  const handleConfirm = async () => {
    setIsWorking(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error("Failed to reinstate enrollment:", error);
    } finally {
      setIsWorking(false);
    }
  };

  return (
    <Dialog onOpenChange={(open) => !open && onClose()} open={isOpen}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Reinstate Enrollment</DialogTitle>
          <DialogDescription className="text-gray-600 dark:text-gray-400">
            Reinstate the cancelled enrollment for{" "}
            <strong>{userFullName}</strong>? They will be moved back into the
            active roster.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button disabled={isWorking} onClick={onClose} variant="outline">
            Cancel
          </Button>
          <Button disabled={isWorking} onClick={handleConfirm}>
            {isWorking ? "Reinstating..." : "Reinstate"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmReinstateEnrollmentModal;
